package gr.tech.site.util

import org.jetbrains.compose.web.css.s

object Constants {
    val sliderSpeed = 60.s
    // State metadata and utility lists have moved to gr.tech.site.data.StateData

    object DESIGN {
        const val MODAL_OVERLAY_INDEX = 1050
    }
}
